module.exports = {"0":{"background":"black","logoLarge":"dealprudence_white_green.png","logoMiddle":"mrlogo.png"}}